module.exports = __webpack_public_path__ + "img/20201127.7ce2d388.webp";